import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { stockItemSingleData } from '../../../../../redux/actions/action-creator';
import MasterListFooter from '../../../../../components/Footer/Master_Footer/MasterListFooter';
import Form from '../../../../../components/Form/Form';
import { toast } from 'react-toastify';
import useData from '../../../../../components/Custom_Hooks/useData';
import { useParams } from 'react-router-dom';
const StockItemView = React.memo(({ data_to_view, closeModal_sec, title }) => {
  const dispatch = useDispatch();
  const [load, setLoad] = useState(false)
  const { userData = null } = useSelector(state => state.auth);

  const initialState = {
    company_id: userData?.id,
    name: '',
    alias_name: '',
    part_no: '',
    item_desc: '',
    notes: '',
    set_default_ledger: 'No',
    under_id: 'Primary',
    under: 'Primary',
    stock_cat_id: 'Not Applicable',
    stock_cat: 'Not Applicable',
    stock_company: 'Not Applicable',
    unit_id: 'Not Applicable',
    unit_name: 'Not Applicable',
    unit_name_first_unit: '',
    unit_name_second_unit: '',
    unit_name_third_unit: '',
    unit_name_fourth_unit: '',
    unit_name_fifth_unit: '',
    alt_unit_id: 'Not Applicable',
    alt_unit_name: 'Not Applicable',
    alt_unit_name_first_unit: '',
    alt_unit_name_second_unit: '',
    alt_unit_name_third_unit: '',
    alt_unit_name_fourth_unit: '',
    alt_unit_name_fifth_unit: '',
    where_unit_name: '',
    where_alternate_unit_name: '',
    where_unit: '0',
    where_alternate_unit: '0',
    default_unit: 'Not Applicable',
    default_unit_id: 'Not Applicable',
    default_unit_rate: '',
    default_unit_rate_id: '',
    weight: 'Not Available',
    per_unit: '',
    per_alt_unit: '',

    set_standard_rate: 'No',
    costing_method: '',
    market_valuation: '',
    provide_behaviour_opt: 'No',
    ignore_diff_physical: 'No',
    ignore_negative_balance: 'No',
    treat_sale_manufacture: 'No',
    treat_purchased_consumed: 'No',
    treat_rejection_scrap: 'No',

    data_item: [
      {
        id: '1',
        godown_name: '',
        location: '',
        quantity: '',
        combination_of_units: '',
        rate: '',
        id_unit: '',
        per: '',
        value: '',
        total_nos_box: '',
        total_no_box_unit: '',
      }
    ],
    modal_type: '',
    total_quantitiy_allocation: '',
    total_amount_allocation: '',
    quantity: '',
    rate: '',
    per: '',
    value: '',
    total_nos_box: '',
    total_no_box_unit: '',
    opening_date: userData?.books_being_date,
    opening_balance: '',

    // gst 

    GST_applicable: 'Applicable',
    HSN_SAC_details: 'As per Company/Stock Group',
    source_details: 'Not Applicable',
    HSN_SAC: '',
    description: '',

    GST_rate_details: 'As per Company/Stock Group',
    source_of_details: 'Not Applicable',
    taxability_type: '',
    IGST_rate: '0',
    CGST_rate: '0',
    SGST_UTGST_rate: '0',
    cess_validation: 'Not Applicable',
    cess_rate: '0',
    application_of_reverse: 'No',
    eligible_tax_credit: 'No',
    rate_of_Duty: '',
    type_of_supply: 'Goods',

  }
  const { data, setData } = useData(initialState);

  useEffect(() => {
    setLoad(true)
    dispatch(stockItemSingleData(data_to_view)).then((response) => {
      if (response?.status) {
        // Transform data_item array to match required format
        const transformedDataItem = response?.data?.data_item?.map(item => ({
          id: item.id || '',
          godown_name: item.location_name || '',
          location: item.location || '',
          quantity: item.quantity || '',
          combination_of_units: item.type || '',
          rate: item.rate || '',
          id_unit: '', // Add if there's a corresponding field
          per: item.per || '',
          value: item.value || '',
          total_nos_box: item.total_nos_box || '',
          total_no_box_unit: item.total_no_box_unit || '',
        })) || [{
          id: '1',
          godown_name: '',
          location: '',
          quantity: '',
          combination_of_units: '',
          rate: '',
          id_unit: '',
          per: '',
          value: '',
          total_nos_box: '',
          total_no_box_unit: '',
        }];

        // Determine modal_type based on quantity and unit_name
        const modalType = (!response.data?.quantity || !response.data?.unit_name || response.data?.unit_name === 'Not Applicable')
          ? 'by_value'
          : 'by_qty';

        setData({
          name: response.data?.name,
          alias_name: response.data?.alias_name,
          part_no: response.data?.part_no,
          item_desc: response.data?.item_desc,
          notes: response.data?.notes,
          set_default_ledger: response.data?.set_default_ledger,

          under: response.data?.under ? response?.data?.under : 'Primary',
          under_id: response.data?.stock_group_name ? response?.data?.stock_group_name : 'Primary',
          stock_cat: response.data?.stock_category_name ? response?.data?.stock_category_name : 'Not Applicable',
          stock_cat_id: response.data?.stock_cat_id ? response?.data?.stock_cat_id : 'Not Applicable',
          stock_company: response.data?.stock_company,

          unit_name: response.data?.unit_name || 'Not Applicable',
          unit_id: response.data?.unit_id || 'Not Applicable',
          unit_name_first_unit: '',
          unit_name_second_unit: '',
          unit_name_third_unit: '',
          unit_name_fourth_unit: '',
          unit_name_fifth_unit: '',

          alt_unit_name: response.data?.alt_unit_name || 'Not Applicable',
          alt_unit_id: response.data?.alt_unit_id || 'Not Applicable',
          alt_unit_name_first_unit: '',
          alt_unit_name_second_unit: '',
          alt_unit_name_third_unit: '',
          alt_unit_name_fourth_unit: '',
          alt_unit_name_fifth_unit: '',

          where_unit_name: response.data?.unit_name || 'Not Applicable',
          where_alternate_unit_name: response.data?.alt_unit_name || 'Not Applicable',
          where_unit: response.data?.where_unit,
          where_alternate_unit: response.data?.where_alternate_unit,

          default_unit: response.data?.default_unit_name,
          default_unit_id: response.data?.default_unit_id,
          default_unit_rate: response.data?.default_unit_rate,
          default_unit_rate_id: response.data?.default_unit_rate_id,

          weight: response.data?.weight,
          per_unit: response.data?.per_unit,
          per_alt_unit: response.data?.per_alt_unit,


          GST_applicable: response.data?.GST_applicable,
          HSN_SAC_details: response.data?.HSN_SAC_details,
          source_details: response.data?.source_details,
          HSN_SAC: response.data?.HSN_SAC,
          description: response.data?.description,
          GST_rate_details: response.data?.GST_rate_details,
          taxability_type: response.data?.taxability_type,
          IGST_rate: response.data?.IGST_rate,
          CGST_rate: response.data?.CGST_rate,
          SGST_UTGST_rate: response.data?.SGST_UTGST_rate,
          cess_validation: response.data?.cess_validation,
          cess_rate: response.data?.cess_rate,
          application_of_reverse: response.data?.application_of_reverse,
          eligible_tax_credit: response.data?.eligible_tax_credit,
          type_of_supply: response.data?.type_of_supply,
          rate_of_Duty: response.data?.rate_of_Duty,
          // opening_balance: response.data?.opening_balance,

          set_standard_rate: response.data?.set_standard_rate,
          costing_method: response.data?.costing_method,
          market_valuation: response.data?.market_valuation,
          provide_behaviour_opt: response.data?.provide_behaviour_opt,
          ignore_diff_physical: response.data?.ignore_diff_physical,
          ignore_negative_balance: response.data?.ignore_negative_balance,
          treat_sale_manufacture: response.data?.treat_sale_manufacture,
          treat_purchased_consumed: response.data?.treat_purchased_consumed,
          treat_rejection_scrap: response.data?.treat_rejection_scrap,

          modal_type: modalType,
          total_quantitiy_allocation: '',
          total_amount_allocation: '',
          quantity: validateZeroValue(response?.data?.quantity),
          rate: validateZeroValue(response?.data?.rate),
          per: validateZeroValue(response?.data?.per),
          value: validateZeroValue(response?.data?.value),
          total_nos_box: '',
          total_no_box_unit: '',
          opening_date: userData?.books_being_date,
          opening_balance: '',
          data_item: transformedDataItem,
          company_id: userData?.id,
          id: data_to_view?.id
        })
        // toast.success(response?.message || 'data found!', {
        //   position: toast.POSITION.TOP_CENTER
        // });
        setLoad(false)
      }
      else {
        toast.warn(response?.message || 'Fail !', {
          position: toast.POSITION.TOP_CENTER
        });
      }
    }).catch(error => {
      console.log(error)
      toast.error(error?.Responsemessage || 'Failed!', {
        position: toast.POSITION.TOP_CENTER
      });
    })
  }, [data_to_view?.id, dispatch])

  const validateZeroValue = (value) => {
    if (!value || value === '0' || value === '0.00' || value === 0) {
      return '';
    }
    return value;
  };
  return (
    <Form
      title='Stock Item View'
      loading={load}
      col='col-7'
      Footer={MasterListFooter}
    >
      <div className='row p-0 ps-2 m-0 mb-1'>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Name
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Alise
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.alias_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Under
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.under_id}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Category
        </div>
        <div
          className="col-1 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          :
        </div>
        <div
          className="col-9 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          {data?.stock_cat}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Company
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.stock_company}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Unit
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.unit_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Alternate Unit
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.alt_unit_name}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Where Unit
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.where_alternate_unit} {data?.where_alternate_unit_name ? data?.where_alternate_unit_name.split(" ").pop() : ''} = {data?.where_unit} {data?.where_unit_name ? data?.where_unit_name.split(" ").pop() : ''}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Description :
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.item_desc}
        </div>
        <div className='border'></div>
        <div
          className="col-2 font_size p-0 m-0 ps-1 text-start fw-bold"
        >
          Notes
        </div>
        <div
          className={`col-1 font_size p-0 m-0 ps-1 text-start`}
        >
          :
        </div>
        <div
          className={`col-9 font_size p-0 m-0 ps-1 text-start`}
        >
          {data?.notes}
        </div>
        <div className='border'></div>
      </div>
      <div className='row p-0 ps-2 m-0 mb-1 pe-2'>
        <div className='col-3 font_size p-0 m-0 ps-1 text-start fw-bold'>
          Godown Name
        </div>
        <div className='col-3 font_size p-0 m-0 ps-1 text-end fw-bold'>
          Quantity
        </div>
        <div className='col-3 font_size p-0 m-0 ps-1 text-end fw-bold'>
          Rate
        </div>
        <div className='col-3 font_size p-0 m-0 ps-1 text-end fw-bold'>
          Amount
        </div>
        <div className='border'></div>
        {data?.data_item?.map((item, index) => (
          <div className='row p-0 m-0 mb-1' key={index}>
            <div className='col-3 font_size p-0 m-0 ps-1 text-start'>
              {item?.godown_name}
            </div>
            <div className='col-3 font_size p-0 m-0 ps-1 text-end'>
              {item?.quantity} {data?.default_unit_id}
            </div>
            <div className='col-3 font_size p-0 m-0 ps-1 text-end'>
              {item?.rate} / {item?.per}
            </div>
            <div className='col-3 font_size p-0 m-0 ps-1 text-end'>
              {item?.value}
            </div>
            <div className='border'></div>
          </div>
        ))}
        {data?.data_item?.length > 0 && (
          <div className='row p-0 m-0 mb-1 fw-bold'>
            <div className='col-3 font_size p-0 m-0 ps-1 text-start'>
              Total
            </div>
            <div className='col-3 font_size p-0 m-0 ps-1 text-end'>
              {data?.data_item.reduce((sum, item) => sum + parseFloat(item.quantity || 0), 0)} {data?.default_unit_id}
            </div>
            <div className='col-3 font_size p-0 m-0 ps-1 text-end'>
            </div>
            <div className='col-3 font_size p-0 m-0 ps-1 text-end'>
              {data?.data_item.reduce((sum, item) => sum + parseFloat(item.value || 0), 0).toFixed(2)}
            </div>
            <div className='border'></div>
          </div>
        )}
      </div>
    </Form>
  )
})

export default StockItemView
